import SignRegionExpandEvent from "../../../../src/events/2023/01/sign-region-expand/main";
import * as React from 'react';
export default {
  SignRegionExpandEvent,
  React
};